import { buildinfo, pkgInfo } from '@/check'
import path from 'node:path'
import { fileURLToPath, pathToFileURL } from 'url'

const __filename = fileURLToPath(import.meta.url)
const __dirname = path.dirname(__filename)

// function findRootDir(dir: string): string {
//     if (existsSync(path.join(dir, 'anybuild.config.mjs'))) {
//         return dir;
//     }

//     const parentDir = path.dirname(dir);
//     if (dir === parentDir) {
//         return dir;
//     }

//     return findRootDir(parentDir);
// }

export const rootDir = path.resolve(__dirname, '../')
export const distDir = path.resolve(rootDir, './dist')

// cli开发时读取src下的，构建之后读取dist下的
export const clientDir = __DEV__
    ? path.resolve(rootDir, './src/engine/vite/client')
    : path.resolve(distDir, './engine/vite/client')
export const cwdDir = process.cwd()
// export const cwdROOT = findRootDir(cwdDir);
// export const ANYBUILD_CONFIG_FILE = path.join(cwdROOT, 'anybuild.config.mjs');

// async function getAnybuildConfigAsync() {
//     try {
//         return (await import(pathToFileURL(ANYBUILD_CONFIG_FILE).href)).default;
//     } catch (err) {
//         err.message && error(err.message, "exit")
//         return {};
//     }
// }

// export async function getAnybuildConfig() {
//     return await getAnybuildConfigAsync();
// }

const dependencies = pkgInfo['dependencies'] ?? {}
const devDependencies = pkgInfo['devDependencies'] ?? {}
const peerDependencies = pkgInfo['peerDependencies'] ?? {}
pkgInfo.globals = pkgInfo['globals'] ?? {}
pkgInfo.exclude = pkgInfo['exclude'] ?? []

const externals = [
    ...Object.keys(dependencies),
    ...Object.keys(devDependencies),
    ...Object.keys(peerDependencies),
].filter((v) => !pkgInfo.exclude.includes(v))

let globals: Record<string, string> = {}
externals.forEach((v) => {
    globals[v] = pkgInfo.globals[v] || v
})

export function getBuildinfoVite() {
    let _config = buildinfo as IBuildInfo<'vite'>
    return _config
}

export function getBuildinfoTsup() {
    let _config = buildinfo as IBuildInfo<'tsup'>
    return _config
}

export {
    buildinfo,
    externals,
    globals,
    dependencies,
    devDependencies,
    peerDependencies,
}
